import { CoastAlertDisplay } from "./CoastAlertDisplay.component";
import { CoastAlert } from "./CoastAlert.model";

interface CoastAlertsDisplayProps {
    alerts: Record<string, CoastAlert>;
}

export function CoastAlertsDisplay({ alerts }: CoastAlertsDisplayProps) {
    return (
        <div>
            {Object.values(alerts).map(alert => (
                <CoastAlertDisplay key={alert.id} {...alert} />
            ))}
        </div>
    );
}
